import {
  ElContainer,
  ElHeader,
  ElFooter,
  ElMain,
  ElButton,
  ElForm,
  ElInput,
  ElFormItem,
  ElNotification,
  ElMessage,
  ElAlert,
  ElTag,
  ElRow,
  ElCol,
  ElCard,
  ElDropdown,
  ElSelect,
  ElOption,
  ElDialog,
  ElProgress,
  ElLink,
  ElAffix,
  ElTabs,
  ElTabPane,
  ElLoading,
  ElDatePicker,
  ElRadio,
  ElRadioGroup,
  ElSkeleton,
  ElSkeletonItem,
  ElPopconfirm,
  ElCarousel,
  ElCheckbox,
  ElSwitch,
  ElCollapse,
  ElMenu,
  ElSubMenu,
  ElMenuItem,
  ElPageHeader,
} from 'element-plus';
import { App } from 'vue';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (app: App) => {
  app
    .use(ElRadioGroup)
    .use(ElRadio)
    .use(ElContainer)
    .use(ElHeader)
    .use(ElFooter)
    .use(ElMain)
    .use(ElButton)
    .use(ElForm)
    .use(ElInput)
    .use(ElFormItem)
    .use(ElMessage)
    .use(ElAlert)
    .use(ElTag)
    .use(ElRow)
    .use(ElCol)
    .use(ElCard)
    .use(ElNotification)
    .use(ElSelect)
    .use(ElOption)
    .use(ElDropdown)
    .use(ElProgress)
    .use(ElLink)
    .use(ElAffix)
    .use(ElDialog)
    .use(ElTabs)
    .use(ElTabPane)
    .use(ElLoading)
    .use(ElSkeleton)
    .use(ElSkeletonItem)
    .use(ElDatePicker)
    .use(ElCarousel)
    .use(ElPopconfirm)
    .use(ElCheckbox)
    .use(ElSwitch)
    .use(ElCollapse)
    .use(ElMenu)
    .use(ElSubMenu)
    .use(ElMenuItem)
    .use(ElPageHeader);
};
